export const AETHERA_ABI = [
  'function BPS() view returns (uint256)',
  'function DAILY_MINING_BPS() view returns (uint256)',
  'function DAILY_POOL_BPS() view returns (uint256)',
  'function DAY() view returns (uint256)',
  'function DEVELOPMENT_BPS() view returns (uint256)',
  'function DIRECT_BPS() view returns (uint256)',
  'function MAX_SP_PER_DAY() view returns (uint256)',
  'function MEMBERSHIP_DURATION() view returns (uint256)',
  'function MIN_MINING_CLAIM() view returns (uint256)',
  'function MIN_SP() view returns (uint256)',
  'function MONTH() view returns (uint256)',
  'function Owner_CAP_BPS() view returns (uint256)',
  'function QUALIFYING_SP() view returns (uint256)',
  'function RENEWAL_FEE() view returns (uint256)',
  'function REWARD_DEDUCTION_BPS() view returns (uint256)',
  'function STANDARD_CAP_BPS() view returns (uint256)',
  'function TOKEN_BUY_BPS() view returns (uint256)',
  'function WEEK() view returns (uint256)',
  'function WEEKLY_POOL_BPS() view returns (uint256)',
  'function YDURATION() view returns (uint256)',
  'function register(address sponsor,uint8 side,uint256 userId)',
  'function renew()',
  'function Stake(uint256 amount)',
  'function claimMining()',
  'function quoteUSDTToAETH(uint256 amount) view returns (uint256)',
  'function quoteAETHToUSDT(uint256 amount) view returns (uint256)',
  'function sellPortfolio(uint256 requestedAeth)',
  'function rollPoolsAndBuyExcess()',
  'function renounceOwnership()',
  'function usdt() view returns (address)',
  'function aeth() view returns (address)',
  'function router() view returns (address)',
  'function qualifyMonthlyOwner()',
  'function claimDailyPool(uint256 id)',
  'function claimWeeklyPool(uint256 id)',
  'function claimMonthlyPool(uint256 id)',
  'function availableCap(address user) view returns (uint256)',
  'function activeDailyPoolId() view returns (uint256)',
  'function activeWeeklyPoolId() view returns (uint256)',
  'function activeMonthlyPoolId() view returns (uint256)',
  'function contractOwner() view returns (address)',
  'function developmentWallet() view returns (address)',
  'function firstID() view returns (address)',
  'function reservedPoolUSDT() view returns (uint256)',
  'function totalLapsedRewardSwapped() view returns (uint256)',
  'function qualificationCounted(address) view returns (bool)',
  'function pendingMining(address account) view returns (uint256)',
  'function todayMining(address account) view returns (uint256)',
  'function estimatedMonthlyMining(address account) view returns (uint256)',
  'function freeUSDTBalance() view returns (uint256)',
  'function protectedPoolUSDT() view returns (uint256)',
  'function getDirects(address user) view returns (address[])',
  'function userIdOf(address) view returns (uint256)',
  'function userIdOwner(uint256) view returns (address)',
  'function currentDayId() view returns (uint256)',
  'function currentWeekId() view returns (uint256)',
  'function currentMonthId() view returns (uint256)',
  'function activeDailyPoolId() view returns (uint256)',
  'function activeWeeklyPoolId() view returns (uint256)',
  'function activeMonthlyPoolId() view returns (uint256)',
  'function launchTime() view returns (uint256)',
  'function dailyPool(uint256) view returns (uint256)',
  'function weeklyPool(uint256) view returns (uint256)',
  'function monthlyOwnerPool(uint256) view returns (uint256)',
  // Read-only compatibility for the currently deployed test contract. The
  // updated contract uses monthlyOwnerPool; this fallback can be removed once
  // every environment has migrated.
  'function monthlyPromoterPool(uint256) view returns (uint256)',
  'function dailyPoolShare(uint256) view returns (uint256)',
  'function weeklyPoolShare(uint256) view returns (uint256)',
  'function monthlyPoolShare(uint256) view returns (uint256)',
  'function dailyAchiever(uint256,address) view returns (bool)',
  'function weeklyAchiever(uint256,address) view returns (bool)',
  'function monthlyAchiever(uint256,address) view returns (bool)',
  'function dailyDirectAbove50Count(uint256,address) view returns (uint256)',
  'function weeklyDirectAbove50Count(uint256,address) view returns (uint256)',
  'function dailyDirectCounted(uint256,address,address) view returns (bool)',
  'function weeklyDirectCounted(uint256,address,address) view returns (bool)',
  'function dailyAchieverCount(uint256) view returns (uint256)',
  'function weeklyAchieverCount(uint256) view returns (uint256)',
  'function monthlyAchieverCount(uint256) view returns (uint256)',
  'function dailyPoolClosed(uint256) view returns (bool)',
  'function weeklyPoolClosed(uint256) view returns (bool)',
  'function monthlyPoolClosed(uint256) view returns (bool)',
  'function dailyPoolClaimed(uint256,address) view returns (bool)',
  'function weeklyPoolClaimed(uint256,address) view returns (bool)',
  'function monthlyPoolClaimed(uint256,address) view returns (bool)',
  'function getUserBasic(address account) view returns (bool registered,bool owner,address sponsor,uint8 placementSide,uint256 expiry)',
  'function getUserStakeInfo(address account) view returns (uint256 totalSP,uint256 lastSPTime,uint256 capLimit,uint256 capUsed,uint256 portfolioCapUsed,uint256 available)',
  'function getUserMiningInfo(address account) view returns (uint256 storedPendingMining,uint256 livePendingMining,uint256 minedTokens,uint256 lastMiningClaimTime,uint256 accountedTokenValue)',
  'function getUserNetworkInfo(address account) view returns (uint256 directBusiness,uint256 teamBusiness15,uint256 activeDirects)',
  'function getUserBinaryInfo(address account) view returns (uint256 leftQualifiedIds,uint256 rightQualifiedIds,uint256 leftBusinessCarry,uint256 rightBusinessCarry)',
  'function userRecords(address) view returns (uint256 miningTaken,uint256 appreciationTaken,uint256 networkTaken,uint256 monthlyTaken,uint256 dailyPoolTaken,uint256 weeklyPoolTaken,uint256 totalSoldUSDT,uint256 lossRestored,uint256 lapsedNetworkReward)',
  'event Registered(address indexed user,address indexed sponsor,uint8 side,uint256 UserId)',
  'event NetworkRewardPaid(address indexed senior,address indexed from,uint256 indexed level,uint256 gross,uint256 deduction,uint256 net)',
  'event NetworkRewardLapsed(address indexed senior,address indexed from,uint256 indexed level,uint256 gross)',
  'event StakeJoined(address indexed user,uint256 amount,uint256 normalBuyUSDT,uint256 lapsedBuyUSDT,uint256 poolRemainderUSDT,uint256 totalBuyUSDT)',
  'event MiningClaimed(address indexed user,uint256 claimValue,uint256 aethAmount)',
  'event PortfolioSold(address indexed user,uint256 aethAmount,uint256 usdtReceived,uint256 appreciation,uint256 lossRestored)',
  'event PoolClaimed(uint8 indexed poolType,uint256 indexed poolId,address indexed user,uint256 amount,uint256 deduction,uint256 net)',
  'event PoolClosed(uint8 indexed poolType,uint256 indexed poolId,uint256 amount,uint256 achievers,uint256 share,uint256 reserved,uint256 tokenBuyRemainder)',
  'event Renewed(address indexed user,uint256 fee,uint256 newExpiry)',
  'event OwnerActivated(address indexed user)',
  'event AethPurchased(uint256 usdtIn)',
  'event RenouncedOwnership(address indexed oldOwner,address indexed newOwner)',
] as const;

export const ERC20_ABI = [
  'event Transfer(address indexed from,address indexed to,uint256 value)',
  'function balanceOf(address account) view returns (uint256)',
  'function allowance(address owner,address spender) view returns (uint256)',
  'function approve(address spender,uint256 amount) returns (bool)',
  'function transferFrom(address from,address to,uint256 amount) returns (bool)',
  'function transfer(address to,uint256 amount) returns (bool)',
  'function decimals() view returns (uint8)',
  'function symbol() view returns (string)',
] as const;
